import { render, staticRenderFns } from "./CBtnSave.vue?vue&type=template&id=11f52421"
import script from "./CBtnSave.vue?vue&type=script&lang=js"
export * from "./CBtnSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports